/**
 * @generated SignedSource<<06d45c4a967a726649440032225a9335>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderWithAI">;
  readonly " $fragmentType": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey";
};
export type jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey$key = {
  readonly " $data"?: jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey$data;
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JQLBuilderWithAI"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "80c3394e44d3807fba8367e369569f00";

export default node;
